import * as IoC from 'inversify';
import { StateSerializationPluginSymbol } from '@/app/state-serialization/api';
import * as Serialization from '../serialization'
import * as SerializationApi from '../serialization/api'
import { QuizSessionSuspendDataStore } from '../common';

export const quizSessionCommonTrackingModule = new IoC.ContainerModule((bind) => {
  bind(QuizSessionSuspendDataStore).toSelf().inSingletonScope()
  bind(StateSerializationPluginSymbol).to(Serialization.QuizSessionStateProtobufSerializer)
  bind(SerializationApi.QuizSessionQuestionStatesProtobufMapper).toSelf()
  bind(SerializationApi.QuizSessionNavigationStateProtobufMapper).toSelf()
  bind(SerializationApi.QuizSessionQuestionTimesStateProtobufMapper).toSelf()
})
